import React, { useState, useEffect, useContext } from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { PacksDispatchContext, PacksContext } from '../ApiProvider';

import { saveAssigns } from 'Helpers/costPacks';

import Button from 'CommonComponents/Button';
import NumberFormat from 'CommonComponents/LocalisedNumberFormat';

import { useToast } from 'Hooks/useToast';

const ContractorPackItemSchema = Yup.object().shape({
    amount: Yup.number().positive().required($t('This value is required')),
});

export default function AmountForm({ packId, itemId }) {
    const packs = useContext(PacksContext).packs;
    const packItems = useContext(PacksContext).packItems;
    const apiCall = useContext(PacksDispatchContext);
    const toast = useToast();
    const [pack, setPack] = useState(false);
    const [packItem, setPackItem] = useState(false);
    const [amount, setAmount] = useState(0);
    const [updatePack, setUpdatePack] = useState(false);

    useEffect(() => {
        setPack((oldPack) => {
            const originalPack = packs.find((p) => p.id == packId);
            const newPack = { ...originalPack, pack_children: [...originalPack.pack_children] };
            const alreadyAssigned = newPack.pack_children.find((packChild) => packChild.id == itemId);
            if (!alreadyAssigned) {
                const newPackItem = { ...packItems.find((pi) => pi.id == itemId) };
                newPack.pack_children.push({ ...newPackItem, pivot: { amount: 0 } });
            } else {
                setAmount(alreadyAssigned.pivot.amount);
            }
            return newPack;
        });

        setPackItem((oldPackItem) => {
            const newPackItem = { ...packItems.find((pi) => pi.id == itemId) };
            return newPackItem;
        });
    }, []);

    const handleDelete = () => {
        setPack((pack) => {
            const newPack = { ...pack };
            newPack.pack_children = newPack.pack_children.filter((item) => item.id != packItem.id);
            setUpdatePack(true);
            return newPack;
        });
        saveAssigns();
    };

    useEffect(() => {
        if (updatePack) {
            apiCall('packEdit', pack);
            setUpdatePack(false);
        }
    }, [updatePack]);

    return (
        <Formik
            enableReinitialize
            initialValues={{
                amount: amount || '',
            }}
            validationSchema={ContractorPackItemSchema}
            onSubmit={(values, actions) => {
                const data = { ...pack };
                const index = data.pack_children.findIndex((item) => item.id == packItem.id);
                const packChild = index === -1 ? undefined : data.pack_children[index];
                if (!packChild || !packChild.pivot) {
                    toast.error($t('This item is no longer available. Please reopen the form and try again.'));
                    actions.setSubmitting(false);
                    return;
                }
                packChild.pivot.amount = values.amount;

                apiCall('packEdit', data);
                saveAssigns();
            }}
        >
            {({ values, errors, touched, isSubmitting, setFieldValue, handleSubmit }) => (
                <>
                    <div className="tw-flex tw-flex-col tw-space-y-1.5">
                        <label className="tw-mt-1 text-input__label" htmlFor="price">
                            {$t('Amount')} *
                        </label>
                        <NumberFormat
                            name="amount"
                            value={values.amount}
                            defaultValue={0}
                            className={errors.amount && touched.amount ? 'tw-border tw-border-red-500 text-input' : 'tw-border-0 text-input'}
                            decimalScale={10}
                            thousandSeparator={true}
                            inputMode="numeric"
                            allowNegative={false}
                            onValueChange={(values) => {
                                const { value } = values;
                                setFieldValue('amount', value);
                            }}
                        />
                        {errors.amount && touched.amount && <div className="tw-text-red-500 tw-text-sm">{errors.amount}</div>}
                    </div>

                    <div className="modal__footer">
                        <Button variant="secondary" onClick={() => apiCall('form', false)} disabled={isSubmitting}>
                            {$t('Cancel')}
                        </Button>
                        <Button variant="danger" onClick={() => handleDelete()} disabled={isSubmitting}>
                            {$t('Delete')}
                        </Button>
                        <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
                            {$t('Update')}
                        </Button>
                    </div>
                </>
            )}
        </Formik>
    );
}
